"use client";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Cookie get function
const getCookie = (name) => {
  if (typeof document === "undefined") return null;
  const cookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith(name + "="));
  return cookie ? cookie.split("=")[1] : null;
};

let storedToken = null;
let storedAdminInfo = null;

if (typeof window !== "undefined") {
  storedToken = getCookie("AdminChatToken");
  const adminString = localStorage.getItem("chat_AdminInfo");
  storedAdminInfo = adminString ? JSON.parse(adminString) : null;
}

// LocalStorage theke userId niye API call
export const fetchAuthData = createAsyncThunk(
  "auth/fetchAuthData",
  async (_, { rejectWithValue }) => {
    try {
      if (!storedAdminInfo?.id) {
        return rejectWithValue("No userId found in localStorage");
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/admin/view/${storedAdminInfo?.id}`,
      );
      console.log(data);
      return data?.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    AuthInfo: storedAdminInfo || null,
    token: storedToken || null,
    isAuthenticated: !!storedToken,
    AuthData: null,
    isAuthLoading: false,
    AuthDataError: null,
    AuthType:"admin"
  },
  reducers: {
    setCredentials: (state, action) => {
      state.AuthInfo = action.payload;
      if (typeof window !== "undefined") {
        localStorage.setItem("chat_AdminInfo", JSON.stringify(action.payload));
      }
    },
    logout: (state) => {
      state.AuthInfo = null;
      state.AuthData = null;
      if (typeof window !== "undefined") {
        localStorage.removeItem("chat_AdminInfo");
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuthData.pending, (state) => {
        state.isAuthLoading = true;
        state.AuthDataError = null;
      })
      .addCase(fetchAuthData.fulfilled, (state, action) => {
        state.isAuthLoading = false;
        state.AuthData = action.payload;
      })
      .addCase(fetchAuthData.rejected, (state, action) => {
        state.isAuthLoading = false;
        state.AuthDataError = action.payload;
      });
  },
});


export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
